import { createTheme, type Components, type Theme } from "@mui/material/styles";
import variants, { type Variant } from "./variants";
import typography from "./typography";
import overrides from "./overrides";
import breakpoints from "./breakpoints";
import props from "./props";
import shadows from "./shadows";

// MUI v7 drops the v4 `adaptV4Theme` adapter. Translate the v4 shape directly:
//   overrides.MuiX.slot → components.MuiX.styleOverrides.slot
//   props.MuiX.foo      → components.MuiX.defaultProps.foo
const buildComponents = (): Components<Theme> => {
  const components: Record<string, { styleOverrides?: unknown; defaultProps?: unknown }> = {};
  Object.keys(overrides).forEach((name) => {
    components[name] = { ...(components[name] || {}), styleOverrides: overrides[name] };
  });
  Object.keys(props).forEach((name) => {
    components[name] = { ...(components[name] || {}), defaultProps: props[name] };
  });
  return components as Components<Theme>;
};

const theme = (variant: Variant) =>
  createTheme({
    spacing: 4,
    breakpoints,
    components: buildComponents(),
    typography,
    shadows,
    palette: variant.palette,
    // custom theme extensions read by sidebar/header/etc.
    body: variant.body,
    header: variant.header,
    sidebar: variant.sidebar,
    section: variant.section,
    name: variant.name,
  });

const themes = variants.map((variant) => theme(variant));

export default themes;
